import {
  AdministrationRepository,
  ListIncidentsParams,
} from '@lib/api/repository/administration/administration.repository';

export default class AdministrationService {
  constructor(private repository: AdministrationRepository) {}

  overview(signal?: AbortSignal) {
    return this.repository.overview(signal);
  }

  platformHealth(signal?: AbortSignal) {
    return this.repository.platformHealth(signal);
  }

  listIncidents(params?: ListIncidentsParams, signal?: AbortSignal) {
    return this.repository.listIncidents(params, signal);
  }

  getIncident(codeOrId: string, signal?: AbortSignal) {
    return this.repository.getIncident(codeOrId, signal);
  }

  updateIncidentStatus(id: string, status: string, notes?: string) {
    return this.repository.updateIncidentStatus(id, status, notes);
  }

  getIncidentMetrics(signal?: AbortSignal) {
    return this.repository.getIncidentMetrics(signal);
  }
}

